import { render, staticRenderFns } from "./DemoPlaceholder.vue?vue&type=template&id=6b0dd636"
import script from "./DemoPlaceholder.vue?vue&type=script&lang=js"
export * from "./DemoPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./DemoPlaceholder.vue?vue&type=style&index=0&id=6b0dd636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports